'use strict';

import FontFaceObserver from 'fontfaceobserver'
import fontFlag from './fonts-flag';

let fontsPromise;
let fontsFinally;
let isResolved = false;

function resolve() {
    if (!isResolved) {
        document.documentElement.className += " fonts-loaded";
    }
}

//global fonts loading error handler
function reject(error) {
    console.error('Fond loading error:', error);
    return Promise.reject(error);
}

if (fontFlag.isResolved()) {
    isResolved = true;
}

let fonts = [];
let robotoLight = new FontFaceObserver('Roboto', {
    weight: 300
});
let robotoRegular = new FontFaceObserver('Roboto', {
    weight: 400
});
let robotoBold = new FontFaceObserver('Roboto', {
    weight: 700
});

let timeout = 4000;
fonts.push(robotoLight.load(null, timeout));
fonts.push(robotoRegular.load(null, timeout));
fonts.push(robotoBold.load(null, timeout));

fontsPromise = Promise.all(fonts).then(() => {
    resolve();
    fontFlag.resolve();
}, (error) => {
    return reject(error);
});

//by chaining from this promise we are sure that all fonts process are finished
fontsFinally = fontsPromise.catch(() => {
    //we do not want to handle just wrap
});


export {fontsPromise};

//by chaining from this promise we are able to catch font loading error
export default fontsFinally;



// WEBPACK FOOTER //
// ./app/general/js/font-loader.js